export default __webpack_public_path__ + "static/media/cvxCRV.2ec13c7e.webp";